module.exports = __webpack_public_path__ + "img/logo.ee774245.svg";